// @flow
import type { PromotionState } from '../reducers/promotionReducer';

export const getPromotionState = (state: Object): PromotionState => state.promotion;



// WEBPACK FOOTER //
// ./src/statsradio/modules/promotions/selectors/promotionSelectors.js